export const medicationsTypes = [
  'Ampoule',
  'Powder',
  'Lotion',
  'Drops',
  'Ointment',
  'Capsule',
  'Vial',
  'Suspension',
  'Tablet',
  'Packet',
  'Cream',
  'Mouth Wash',
  'Spray',
  'Syrup',
  'Acrosol',
  'Suppository',
  'Solution',
  'Gel',
  'Injection',
  'Inhaler',
  'Sachet'
]

export const medicationsMethods = [
  'IP (Intraperitoneal)',
  'BUCC (Buccal)',
  'TP (Topical)',
  'IM (Intramuscular)',
  'IV (Intravenous)',
  'PR (Per Rectum)',
  'SL (Sublingual)',
  'IN (Intranasal)',
  'PO (By Mouth)',
  'ID (Intradermal)',
  'INH (Inhaled)',
  'OPH (In the eye)',
  'OT (In the ear)',
  'SC (Subcutaneous)',
  'PV (Vaginal)'
]

export const patientTitles = ['mr', 'mrs', 'miss', 'ms', 'dr']

export const patientRelations = ['spouse', 'parent', 'partner', 'friend']
